import React from 'react'
import Switch from '@mui/material/Switch'
import { useField } from 'formik'
import { SwitchProps } from '@mui/material/Switch/Switch'
import FormControlLabel from '@mui/material/FormControlLabel'
import { FormControlLabelProps } from '@mui/material/FormControlLabel/FormControlLabel'
import { FormHelperText } from '@mui/material'

interface IFormControlProps extends FormControlLabelProps {
  control: React.ReactElement<any, any> | null
}

type FormikSwitcherProps = SwitchProps & {
  formControlProps: IFormControlProps
  onChangeSubmit?(): void
}

const FormikSwitcher: React.FC<FormikSwitcherProps> = ({
  formControlProps,
  onChangeSubmit,
  ...props
}) => {
  const [{ onChange, ...field }, { error, touched }] = useField(props.name)
  const handleChange = async e => {
    onChange(e)
    if (onChangeSubmit) {
      onChangeSubmit()
    }
  }
  return (
    <>
      <FormControlLabel
        labelPlacement={'end'}
        {...formControlProps}
        checked={!!field.value}
        control={
          formControlProps.control || (
            <Switch {...field} onChange={handleChange} color='secondary' />
          )
        }
      />
      {!!(touched && error) && (
        <FormHelperText className='px-14' error={!!(touched && error)}>
          {touched && error}
        </FormHelperText>
      )}
    </>
  )
}

export default FormikSwitcher
